import React from 'react';
import { MapPinIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const markets = ['Eko Market', 'Balogun Market', 'Mile 12 and others'];
export function Markets() {
  return <section id="markets" className="w-full bg-warmgray py-14 sm:py-16" data-id="element-105" data-mp="2bks96zk4m6v7">
      <div className="mx-auto max-w-6xl px-4 text-center sm:px-6" data-id="element-106" data-mp="2bmlgmh2kcv49">
        <Reveal data-id="element-107" data-mp="2gkdd7oe5l5es">
          <h2 className="font-display text-3xl uppercase tracking-tight text-purple sm:text-4xl" data-id="element-108" data-mp="2gkwud2vzbprr">Markets I Go To</h2>
        </Reveal>

        <ul className="mt-6 flex flex-wrap justify-center gap-3" data-id="element-109" data-mp="2pk0ca3jetz4o">
          {markets.map((market, index) => <Reveal as="li" key={market} delay={index * 0.08} className="flex items-center gap-2 rounded-full bg-purple px-5 py-2.5 text-sm font-medium text-white shadow-soft transition duration-300 hover:-translate-y-1 hover:bg-purple-soft hover:shadow-lift" data-id="element-110" data-mp="2uba1j311r0g1" data-mpi={index}>
              <MapPinIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-111" data-mp="34b0uh09yl7e0" />
              {market}
            </Reveal>)}
        </ul>

        <Reveal delay={0.15} data-id="element-112" data-mp="2z7rlyr8cqrie">
          <p className="mt-5 text-sm text-ink/60" data-id="element-113" data-mp="2z8t0x6shny5e">Fresh from the source, at real market prices.</p>
        </Reveal>
      </div>
    </section>;
}